import { Icons } from '@assets/svg'
import { colors, theme } from '@config/theme'
import { useMediaQuery } from '@mui/material'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

import { Combinable } from '../Combinable/Combinable'
import { DayLengthText } from '../DayLengthText/DayLengthText'

type DayLengthProps = {
  day_length?: 'FULL' | 'HALF_AM' | 'HALF_PM' | 'OVERNIGHT' | null
  half_day_combinable?: boolean
}

export const DayLengthDetailPage: React.FC<DayLengthProps> = ({ day_length, half_day_combinable }) => {
  const isLargeScreen: boolean = useMediaQuery(theme.device['md'])

  const getDayLengthInfo = () => {
    switch (day_length) {
      case 'FULL':
        return {
          dayLengthIcon: (
            <Icons.FullSun dataTestid="day_length_icon" dataStatus="full-sun" size={isLargeScreen ? 40 : 20} />
          ),
        }
      case 'HALF_AM':
        return {
          dayLengthIcon: (
            <Icons.HalfSunLeft dataTestid="day_length_icon" dataStatus="left-sun" size={isLargeScreen ? 16 : 10} />
          ),
        }
      case 'HALF_PM':
        return {
          dayLengthIcon: (
            <Icons.HalfSunRight dataTestid="day_length_icon" dataStatus="right-sun" size={isLargeScreen ? 16 : 10} />
          ),
        }
      case 'OVERNIGHT':
        return {
          dayLengthIcon: <Icons.Moon dataTestid="day_length_icon" dataStatus="moon" size={isLargeScreen ? 30 : 20} />,
        }
      default:
        return {
          dayLengthIcon: (
            <Icons.FullSun dataTestid="day_length_icon" dataStatus="full-sun" size={isLargeScreen ? 40 : 20} />
          ),
        }
    }
  }

  const { dayLengthIcon } = getDayLengthInfo()

  return (
    <ThemeProvider theme={theme}>
      <DayLengthWrapper>
        <DayLengthContent>
          {dayLengthIcon}
          <RightSideWrapper>
            <StyledDayLengthText>
              <DayLengthText day_length={day_length} />
            </StyledDayLengthText>
            <CombinableWrapper>
              <Combinable show={half_day_combinable} />
            </CombinableWrapper>
          </RightSideWrapper>
        </DayLengthContent>
      </DayLengthWrapper>
    </ThemeProvider>
  )
}

const DayLengthWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const DayLengthContent = styled.div`
  display: flex;
  align-items: center;

  flex-direction: column;
  @media${({ theme }) => theme.device['md']} {
    flex-direction: row;
    > svg {
      margin-left: 0.25rem;
    }
  }
`
const RightSideWrapper = styled.div`
  display: flex;
  margin-left: 0.5rem;
  text-align: left;
  gap: 0;
  align-items: start;
  flex-direction: column;
`
const StyledDayLengthText = styled.span`
  font-weight: 600;
  color: ${colors.brandGray900};
  font-size: 1rem;
  line-height: 1.5rem;
  @media${({ theme }) => theme.device['md']} {
    line-height: 30px;
    font-size: 18px;
  }
`

const CombinableWrapper = styled.span`
  color: ${colors.brandGray700};
`
